import { render, staticRenderFns } from "./inyeccion-y-maquila.vue?vue&type=template&id=76d2c34e&lang=html"
import script from "./inyeccion-y-maquila.vue?vue&type=script&lang=js"
export * from "./inyeccion-y-maquila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports